// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3Q0Ia","topBottomGutter":"Layout_topBottomGutter__35WQp"};